<template>
  <div>
    <div id="home">
      <img style="width: 20vw;" src="../assets/imgs/success.png"/>
      <h1>계산이 완료되었습니다</h1>
      <p>결과 확인을 위해<br/>카카오톡 로그인이 필요합니다.</p>
      <div class="btn" @click="go_kakao_login()">
        <img src="../assets/imgs/kakao.png"/>
        카카오 1초만에 받기 시작
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters, mapActions } from 'vuex'
  import { ACCESS_TOKEN } from '@/store/mutation-types'
  import moment from 'moment/moment';
  export default {
    name: 'KakaoLogin',
    components: {

    },
    data() {
      return {
      }
    },
    methods:{
      ...mapActions(["Login"]),
      go_kakao_login(){
        let path;
        if (this.$route.query && this.$route.query.redirect && this.$route.query.redirect !== '') {
          path = this.$route.query.redirect
        } else {
          path = "/result"
        }
        window.location.href = `https://kauth.kakao.com/oauth/authorize?client_id=${process.env.VUE_APP_KAKAO_CLIENT_ID}&redirect_uri=` + process.env.VUE_APP_KAKAO_REDIRECT_URI + `&response_type=code&state=` + path
      },
    }
  }
</script>

<style scoped>
  *{font-size:16px;font-size:inherit;box-sizing: border-box;margin:0px;padding:0px;}
  #home{height: 100vh;display: flex;flex-direction: column;width: 100%;padding:20px;align-items: center;justify-content: center;}
  h1{color:#333333;font-size: 24px;text-align: center;margin:20px 0 10px 0;}
  p{color: #717B85;text-align: center;}
  .btn{display: flex;justify-content: center;background:#FFDE33;margin-top:30px;align-items: center;padding:0 20px;height: 52px;border-radius: 26px;font-weight: bold;}
  .btn img{width: 16px;margin-right: 6px;}
</style>
